import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import AppLoader from "../../../components/AppLoader";
import GlobalTable from "../../../components/Tables/GlobalTable";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import { getCompanyServices } from "../../../services/company/serviceCategoryApiFn";
import { handleOpenSnackBar } from "../../../utils";
import DurationDialog from "./DurationDialog";
import EditServiceDialog from "./EditServiceDialog";
import PricingDialog from "./PricingDialog";
import { t } from "i18next";

const headerData = [
  "serviceDetails",
  "description",
  "adminPercentage",
  "companyPercentage",
  "workingCost",
  "workingDuration",
  "actions",
];

const tableRows = [
  "sub_category_name",
  "sub_category_description",
  "sub_category_per",
  "company_per",
  "sub_category_cost",
  "sub_category_duration",
  "actions",
];

const CategoryService = () => {
  const dispatch = useDispatch();
  const openPricingDialog = useRef(null);
  const openDurationDialog = useRef(null);
  const editSericeDialogRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [allSubServices, setAllSubServices] = useState([]);
  const userData = useSelector((state) => state.userData.user);
  const activeTab = useSelector((state) => state.activeTab.tabs);
  const serviceId = useSelector((state) => state.serviceIdReducer.serviceId);

  useEffect(() => {
    if (userData && serviceId) {
      fetchAllSubServices();
    }
  }, []);

  const fetchAllSubServices = async () => {
    try {
      setIsLoading(true);
      const response = await getCompanyServices(userData?.adminId, serviceId);
      if (response?.data?.status === "success") {
        let subServices = response.data.data;
        setAllSubServices(subServices);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditService = (params) => {
    editSericeDialogRef.current.isVisible({
      type: "edit",
      getData: fetchAllSubServices,
      data: params.row,
    });
  };

  const handleSeePricing = (params) => {
    openPricingDialog.current.openDialog({ data: params });
  };

  const handleSeeDuration = (params) => {
    openDurationDialog.current.openDialog({ data: params });
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <AppContainer
        primaryHeading={t("listOfSubServiceCategories")}
        secondaryHeading={t("editSubServices")}
        showBackButton={true}
        showSerach={true}
        handleBack={() => {
          dispatch(
            setActiveTab({
              ...activeTab,
              company_catalogue: "service_category",
            })
          );
        }}
      >
        {/* <Typography mb={1} variant="h6" fontWeight={500}>
          Cleaning Service
        </Typography> */}

        <GlobalTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={allSubServices}
          showActions={true}
          showEdit={true}
          handleEdit={handleEditService}
          handleSeePricing={handleSeePricing}
          handleSeeDuration={handleSeeDuration}
        />

        <EditServiceDialog ref={editSericeDialogRef} />
        <PricingDialog ref={openPricingDialog} />
        <DurationDialog ref={openDurationDialog} />
      </AppContainer>
    </>
  );
};

export default CategoryService;
